import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { queryShadowElement } from '@client/app/utils/query-shadow-element.util';

@Injectable({
    providedIn: 'root',
})
export class NgbModalOpenerService {
    constructor (
        @Inject(DOCUMENT) private document: Document,
        private modalService: NgbModal,
    ) {}

    open (options: any): NgbModalRef {
        let dialogWrapper = queryShadowElement('#common-dialog-wrapper', this.document.body);

        if (!dialogWrapper) {
            dialogWrapper = this.document.body;
        }

        const modalParent = this.document.createElement('div');
        dialogWrapper.appendChild(modalParent);

        const modal = this.modalService.open(options.component, {
            ...options,
            container: modalParent,
        });

        if (options.resolve) {
            modal.componentInstance.resolve = options.resolve;
            modal.componentInstance.close.subscribe((payload) => {
                modal.close(payload);
            });
            modal.componentInstance.dismiss.subscribe(() => {
                modal.dismiss();
            });
        }

        modal.closed.subscribe(() => {
            setTimeout(() => {
                modalParent.remove();
            }, 300);
        });

        return modal;
    }
}
